import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';


export default function Dashboard() {
  const [cotizaciones, setCotizaciones] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const token = localStorage.getItem('token');
  const esCliente = usuario.rol === 'cliente';

  const cotizacionesFiltradas = cotizaciones.filter(c => {
    const q = busqueda.trim().toLowerCase();
    if (!q) return true;
    return [c.numero, c.razon_social, c.estado]
      .some(campo => (campo || '').toLowerCase().includes(q));
  });

  useEffect(() => {
    axios.get(`${API}/cotizaciones`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      const todas = res.data;
      if (esCliente) {
        setCotizaciones(todas.filter(c => c.cliente_id === usuario.id));
      } else {
        setCotizaciones(todas);
      }
    });
  }, []);

  const cerrarSesion = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const eliminarCotizacion = async (c) => {
    if (!window.confirm(`¿Eliminar la cotización ${c.numero} de forma permanente? Esta acción no se puede deshacer.`)) return;
    try {
      await axios.delete(`${API}/cotizaciones/${c.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCotizaciones(prev => prev.filter(x => x.id !== c.id));
    } catch (err) {
      alert('Error al eliminar: ' + (err.response?.data?.error || err.message));
    }
  };

  // Crea una copia independiente (borrador) de la cotización y va directo a
  // editarla, para no tener que armar una similar desde cero.
  const duplicarCotizacion = async (c) => {
    try {
      const res = await axios.post(`${API}/cotizaciones/${c.id}/duplicar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.href = `/cotizacion/${res.data.id}/editar`;
    } catch (err) {
      alert('Error al duplicar: ' + (err.response?.data?.error || err.message));
    }
  };

  const estadoColor = {
    borrador: '#888', enviada: '#2196F3', en_aprobacion: '#FF9800',
    aprobada: '#4CAF50', rechazada: '#f44336', ganada: '#1B5E20', perdida: '#B71C1C'
  };

  return (
    <div style={s.page}>
      <div style={s.header} className="rf-header">
        <div>
          <h1 style={s.titulo}>La Fábrica D'Rivera</h1>
          <p style={s.sub}>{esCliente ? 'Mis Cotizaciones' : 'Sistema de Cotizaciones'}</p>
        </div>
        <div style={s.headerRight} className="rf-header-right">
          <span style={s.usuario}>{usuario.nombre}</span>
          {!esCliente && <button style={s.btnNueva} onClick={() => window.location.href='/nueva'}>+ Nueva Cotización</button>}
          {!esCliente && <button style={s.btnNav} onClick={() => window.location.href='/clientes'}>Clientes</button>}
          {!esCliente && <button style={s.btnNav} onClick={() => window.location.href='/productos'}>Productos</button>}
          <button style={s.btnSalir} onClick={cerrarSesion}>Salir</button>
        </div>
      </div>

      <div style={s.container} className="rf-container">
        <h2 style={s.seccion}>{esCliente ? 'Mis Cotizaciones' : 'Cotizaciones'}</h2>
        <input
          type="text"
          style={s.busqueda}
          placeholder="🔍 Buscar por número, cliente o estado..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
        />
        <div className="rf-tabla-wrap">
        <table style={s.tabla}>
          <thead>
            <tr style={s.theadRow}>
              <th style={s.th} className="rf-th">Número</th>
              {!esCliente && <th style={s.th} className="rf-th">Cliente</th>}
              <th style={s.th} className="rf-th">Fecha</th>
              <th style={s.th} className="rf-th">Total</th>
              <th style={s.th} className="rf-th">Estado</th>
              <th style={s.th} className="rf-th">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {cotizacionesFiltradas.length === 0 && (
              <tr><td colSpan="6" style={s.vacio}>{cotizaciones.length === 0 ? 'No hay cotizaciones aún' : 'No se encontraron cotizaciones'}</td></tr>
            )}
            {cotizacionesFiltradas.map(c => (
              <tr key={c.id} style={s.row}>
                <td style={s.td} className="rf-td">{c.numero}</td>
                {!esCliente && <td style={s.td} className="rf-td">{c.razon_social}</td>}
                <td style={s.td} className="rf-td">{new Date(c.created_at).toLocaleDateString('es-CO')}</td>
                <td style={s.td} className="rf-td">$ {Number(c.total).toLocaleString('es-CO')}</td>
                <td style={s.td} className="rf-td">
                  <span style={{...s.badge, background: estadoColor[c.estado] || '#888'}}>
                    {(c.estado || 'borrador').replace('_', ' ').toUpperCase()}
                  </span>
                </td>
                <td style={s.td} className="rf-td">
                  <button style={s.btnVer}
                    onClick={() => window.location.href=`/cotizacion/${c.id}`}>
                    Ver
                  </button>
                  {!esCliente && (
                    <button style={s.btnDuplicar} onClick={() => duplicarCotizacion(c)}>
                      Duplicar
                    </button>
                  )}
                  {!esCliente && (
                    <button style={s.btnEliminar} onClick={() => eliminarCotizacion(c)}>
                      Eliminar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight:'100vh', background:'#f5f5f5' },
  header:     { background:'#1a1a2e', padding:'1rem 2rem', display:'flex', justifyContent:'space-between', alignItems:'center' },
  titulo:     { color:'#c8a951', fontSize:'22px', fontWeight:'700' },
  sub:        { color:'#aaa', fontSize:'13px' },
  headerRight:{ display:'flex', alignItems:'center', gap:'12px' },
  usuario:    { color:'#fff', fontSize:'14px' },
  btnNueva:   { background:'#c8a951', color:'#fff', border:'none', padding:'8px 16px', borderRadius:'8px', fontWeight:'600' },
  btnSalir:   { background:'transparent', color:'#aaa', border:'1px solid #aaa', padding:'8px 16px', borderRadius:'8px' },
  container:  { padding:'2rem' },
  seccion:    { marginBottom:'1rem', color:'#1a1a2e' },
  busqueda:   { width:'100%', maxWidth:'420px', padding:'10px 14px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', marginBottom:'1rem', display:'block', background:'#fff' },
  tabla:      { width:'100%', borderCollapse:'collapse', background:'#fff', borderRadius:'10px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.08)' },
  theadRow:   { background:'#1a1a2e' },
  th:         { padding:'12px 16px', color:'#c8a951', textAlign:'left', fontSize:'13px', fontWeight:'600' },
  row:        { borderBottom:'1px solid #f0f0f0' },
  td:         { padding:'12px 16px', fontSize:'14px' },
  vacio:      { padding:'2rem', textAlign:'center', color:'#aaa' },
  badge:      { padding:'4px 10px', borderRadius:'20px', color:'#fff', fontSize:'12px', fontWeight:'600' },
  btnVer:     { background:'#1a1a2e', color:'#fff', border:'none', padding:'6px 14px', borderRadius:'6px', fontSize:'13px', marginRight:'6px', cursor:'pointer' },
  btnDuplicar:{ background:'#fff', color:'#c8a951', border:'1px solid #c8a951', padding:'6px 14px', borderRadius:'6px', fontSize:'13px', marginRight:'6px', cursor:'pointer' },
  btnEliminar:{ background:'#fee', color:'#c00', border:'1px solid #fcc', padding:'6px 14px', borderRadius:'6px', fontSize:'13px', cursor:'pointer' },
  btnNav:     { background:'transparent', color:'#c8a951', border:'1px solid #c8a951', padding:'8px 16px', borderRadius:'8px' },
};